export const getBaggageFromFare = (fare, fallbackSegments) => {
	const seg = fallbackSegments?.[0];
	const baggage = fare?.baggage;
	return {
		checkin: baggage?.checkin ?? seg?.checkinBaggage,
		cabin: baggage?.cabin ?? seg?.cabinBaggage,
	};
};

export const applyBaggageToSegments = (segments, baggage) => {
	if (!baggage || !segments) return segments;
	return segments.map((seg) => ({
		...seg,
		checkinBaggage: baggage.checkin ?? seg.checkinBaggage,
		cabinBaggage: baggage.cabin ?? seg.cabinBaggage,
		childCheckinBaggage: baggage.childCheckin ?? seg.childCheckinBaggage,
		childCabinBaggage: baggage.childCabin ?? seg.childCabinBaggage,
		infantCheckinBaggage: baggage.infantCheckin ?? seg.infantCheckinBaggage,
		infantCabinBaggage: baggage.infantCabin ?? seg.infantCabinBaggage,
	}));
};

export const mergeFlightWithSelectedFare = (flight, selectedFare) => {
	if (!selectedFare) return flight;
	const merged = { ...flight, selectedFare };
	const baggage = selectedFare.baggage;
	if (flight.segments) {
		merged.segments = applyBaggageToSegments(flight.segments, baggage);
	}
	if (flight.onwardSegments) {
		merged.onwardSegments = applyBaggageToSegments(flight.onwardSegments, baggage);
	}
	if (flight.returnSegments) {
		merged.returnSegments = applyBaggageToSegments(flight.returnSegments, baggage);
	}
	return merged;
};
